import APIclient from "API/Client";

export const getTransactionTags = (transactionId) => {
  return APIclient.getData(`/api/v1/transaction-tag/${transactionId}`);
};
